
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#000","stroke-width":"1.5","fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M1.95 3.028l1.375 1.735V8.86c-.037 1.548 1.758 2.935 3.438 4.358M6.059 7.743L7.68 9.405a1.117 1.117 0 001.6-1.56L6.76 5.272V3.93a5.765 5.765 0 00-.897-2.247"}}),_c('path',{attrs:{"d":"M6.764 8.458v11.108c0 .76.616 1.376 1.376 1.376h6.878M22.584 20.97l-1.376-1.734V15.14c.032-1.338-1.303-2.555-2.751-3.778v4.877l-1.605-1.644a1.117 1.117 0 00-1.6 1.56l2.526 2.575v1.34c.138.803.443 1.567.897 2.244M13.164 17.503H9.516M10.89 14.063H9.517M19.833 5.81a4.127 4.127 0 11-4.127-4.127"}}),_c('path',{attrs:{"d":"M19.833 2.714l-3.76 3.76a.517.517 0 01-.734 0L14.157 5.29"}})])])
          )
        }
      }
    